import Address from "components/Parts/Address";
import TicketCalendar from "components/Parts/CalendarParts/TicketCalendar"
import Timer from "components/Parts/Timer";
import DndItem from "components/Parts/CalendarParts/DndItem";
import Event from "components/Parts/CalendarParts/Event"
import EngineerCalendar from "./CalendarParts/EngineerCalendar";
import AddressCondensed from "./AddressCondensed";
import AddressLong from "./AddressLong";
import RegionSelectToggle from "./RegionSelectToggle";
import FeedbackLocationSelect from "./FeedbackLocationSelect";
import EngineerHDCard from "./EngineerHDCard"
import TicketScoreBreakdown from "./TicketScoreBreakdown"
import ScheduleComponent from "./ScheduleComponent"
import Tickers from "./Tickers";
import FDCountDisplay from "./FDCountDisplay";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
import DataEntry from "./DataEntry";
import UserDocsDisplay from "./UserDocsDisplay";
import {EditableTableRow} from "./EditableTableRow";
import ScheduleHeader from "./ScheduleHeader";
import HelpdeskCallBanner from "./Banners/HelpdeskCallBanner";
import HelpdeskCallModal from "./Banners/HelpdeskCallModal";
import MissingFinancialBanner from "./Banners/MissingFinancialBanner";

const Parts =  {
	Address: Address,
	AddressLong: AddressLong,
	AddressCondensed: AddressCondensed,
	DataEntry: DataEntry,
	UserDocsDisplay: UserDocsDisplay,
	Timer : Timer,
	TicketCalendar:TicketCalendar,
	EditableTableRow:EditableTableRow,
	EngineerCalendar:EngineerCalendar,
	EngineerHDCard: EngineerHDCard,
	FDCountDisplay: FDCountDisplay,
	PrivacyPolicy: PrivacyPolicy,
	TermsOfService: TermsOfService,
	ScheduleComponent: ScheduleComponent,
	ScheduleHeader: ScheduleHeader,
	DndItem:DndItem,
	Event: Event,
	RegionSelectToggle: RegionSelectToggle,
	FeedbackLocationSelect: FeedbackLocationSelect,
	TicketScoreBreakdown: TicketScoreBreakdown,
	Tickers,
	HelpdeskCallBanner,
	HelpdeskCallModal,
	MissingFinancialBanner,
};

export default Parts;
